<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Twitch Sub Anniversary Messages</h1>
    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
        <label class="block text-gray-700">Trashed:</label>
        <select v-model="form.trashed" class="mt-1 w-full form-select">
          <option :value="null" />
          <option value="with">With Trashed</option>
          <option value="only">Only Trashed</option>
        </select>
      </search-filter>
      <inertia-link class="btn-indigo" :href="route('anniversaries.create')">
        <span>Add</span>
        <span class="hidden md:inline">Anniversary Message</span>
      </inertia-link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">Anniversary (in month)</th>
          <th class="px-6 pt-6 pb-4">Message</th>
        </tr>
        <tr v-for="anniversary in anniversaries.data" :key="anniversary.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('anniversaries.edit', anniversary.id)" tabindex="-1">
              <badge-index-preview :preview_anniversary=anniversary.anniversary />
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-2 flex items-center focus:text-indigo-500" :href="route('anniversaries.edit', anniversary.id)">
              <index-preview :preview_message=anniversary.message />
              <icon v-if="anniversary.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2" />
            </inertia-link>
          </td>
          <td class="border-t w-px">
            <inertia-link class="px-4 flex items-center" :href="route('anniversaries.edit', anniversary.id)" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </inertia-link>
          </td>
        </tr>
        <tr v-if="anniversaries.data.length === 0">
          <td class="border-t px-6 py-4" colspan="5">No anniversary messages found.</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="anniversaries.links" />
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import IndexPreview from '../../Shared/IndexPreview.vue'
import BadgeIndexPreview from '../../Shared/BadgeIndexPreview.vue'


export default {
  metaInfo: { title: 'Anniversaries' },
  components: {
    Icon,
    Pagination,
    SearchFilter,
    IndexPreview,
    BadgeIndexPreview,
  },
  layout: Layout,
  props: {
    filters: Object,
    anniversaries: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      }
    }
  },
  computed: {
    nodes(message) {
        console.log(message)
        return message.split(' ')
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function() {
        this.$inertia.get(this.route('anniversaries'), pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
